<template>
  <div class="cookie-settings-overlay" @click.self="$emit('close')">
    <div class="cookie-settings-container">
      <div class="cookie-settings-header">
        <h3 class="cookie-settings-title">Cookie 设置</h3>
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>
      <div class="cookie-settings-content">
        <p class="cookie-settings-description">
          您可以选择启用或禁用不同类别的 Cookie。必要的 Cookie 是网站正常运行所必需的，无法禁用。
        </p>
        
        <div class="cookie-category">
          <div class="category-header">
            <div>
              <h4 class="category-title">必要 Cookie</h4>
              <p class="category-description">这些 Cookie 对于网站的正常运行是必不可少的，无法禁用。</p>
            </div>
            <label class="toggle-switch disabled">
              <input type="checkbox" checked disabled>
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
        
        <div class="cookie-category">
          <div class="category-header">
            <div>
              <h4 class="category-title">分析 Cookie</h4>
              <p class="category-description">帮助我们了解访问者如何使用我们的网站，以便我们可以改进网站体验。</p>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" v-model="preferences.analytics">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
        
        <div class="cookie-category">
          <div class="category-header">
            <div>
              <h4 class="category-title">营销 Cookie</h4>
              <p class="category-description">用于跟踪访问者在网站上的活动，以便向他们展示相关广告。</p>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" v-model="preferences.marketing">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
        
        <div class="cookie-category">
          <div class="category-header">
            <div>
              <h4 class="category-title">偏好 Cookie</h4>
              <p class="category-description">允许网站记住您的偏好设置，如语言选择和网站外观。</p>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" v-model="preferences.preferences">
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>
      <div class="cookie-settings-footer">
        <button class="consent-btn reject-btn" @click="rejectAll">全部拒绝</button>
        <button class="consent-btn accept-btn" @click="savePreferences">保存偏好</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'CookieSettingsDialog',
  emits: ['close', 'save'],
  setup(props, { emit }) {
    // 默认偏好设置
    const preferences = ref({
      necessary: true, // 必要的Cookie始终启用
      analytics: false,
      marketing: false,
      preferences: false
    })
    
    // 检查是否有保存的偏好
    const savedPreferences = localStorage.getItem('cookie-preferences')
    if (savedPreferences) {
      try {
        const parsed = JSON.parse(savedPreferences)
        preferences.value = {
          ...preferences.value,
          ...parsed
        }
      } catch (e) {
        console.error('无法解析保存的Cookie偏好', e)
      }
    }
    
    // 保存偏好设置
    const savePreferences = () => {
      localStorage.setItem('cookie-consent', 'custom')
      localStorage.setItem('cookie-preferences', JSON.stringify(preferences.value))
      emit('save', preferences.value)
      emit('close')
    }
    
    // 拒绝所有非必要Cookie
    const rejectAll = () => {
      preferences.value.analytics = false
      preferences.value.marketing = false
      preferences.value.preferences = false
      savePreferences()
    }
    
    return {
      preferences,
      savePreferences,
      rejectAll
    }
  }
}
</script>

<style scoped>
.cookie-settings-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.cookie-settings-container {
  background-color: var(--card-background);
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  animation: fade-in 0.3s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.cookie-settings-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cookie-settings-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: var(--text-tertiary);
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: var(--hover-color);
  color: var(--text-primary);
}

.cookie-settings-content {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}

.cookie-settings-description {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-secondary);
  margin-bottom: 20px;
}

.cookie-category {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.cookie-category:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.category-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--text-primary);
}

.category-description {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.5;
}

/* 开关样式 */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--border-color);
  transition: .4s;
  border-radius: 34px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background: linear-gradient(90deg, #4461F2 0%, #38BFFF 100%);
}

input:checked + .toggle-slider:before {
  transform: translateX(24px);
}

.toggle-switch.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.toggle-switch.disabled .toggle-slider {
  cursor: not-allowed;
}

.cookie-settings-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.consent-btn {
  padding: 10px 20px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.accept-btn {
  background: linear-gradient(90deg, #4461F2 0%, #38BFFF 100%);
  color: white;
}

.accept-btn:hover {
  box-shadow: 0 8px 16px rgba(68, 97, 242, 0.25);
  transform: translateY(-2px);
}

.reject-btn {
  background-color: transparent;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.reject-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

@media (max-width: 768px) {
  .cookie-settings-container {
    width: 95%;
    max-height: 80vh;
  }
  
  .category-header {
    flex-direction: column;
    gap: 12px;
  }
  
  .toggle-switch {
    align-self: flex-start;
  }
  
  .cookie-settings-footer {
    flex-direction: column;
  }
  
  .cookie-settings-footer button {
    width: 100%;
  }
}
</style> 